import { GridConfigOption } from '../GridProps'

export const defaultGridConfig = {
  numColumns: 1,
  rowGap: 16,
  columnGap: 8,
}

export const getItemStyles = (opts?: GridConfigOption) => ({
  ...(opts?.numColumns && { width: `${100 / opts.numColumns}%` as '100%' }),
  ...(opts?.columnGap && { paddingHorizontal: opts.columnGap / 2 }),
  ...(opts?.rowGap && { paddingVertical: opts.rowGap / 2 }),
})

export const getWrapperStyles = (opts?: GridConfigOption) => ({
  ...(opts?.columnGap && { marginHorizontal: -(opts.columnGap / 2) }),
  ...(opts?.rowGap && { marginVertical: -(opts.rowGap / 2) }),
})

export const getListHeaderStyles = (opts?: GridConfigOption) => ({
  ...(opts?.columnGap && { paddingHorizontal: opts.columnGap / 2 }),
  ...(opts?.rowGap && { marginBottom: -opts.rowGap / 2, paddingTop: opts.rowGap / 2 }),
})

export const getListFooterStyles = (opts?: GridConfigOption) => ({
  ...(opts?.columnGap && { paddingHorizontal: opts.columnGap / 2 }),
  ...(opts?.rowGap && { paddingBottom: opts.rowGap / 2, marginTop: -(opts.rowGap / 2) }),
})
